import { render, staticRenderFns } from "./ProjectPlanEditor.vue?vue&type=template&id=8037f284"
import script from "./ProjectPlanEditor.vue?vue&type=script&lang=ts"
export * from "./ProjectPlanEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports